import { render, staticRenderFns } from "./columnsDialog.vue?vue&type=template&id=54d8e6b6&scoped=true&"
import script from "./columnsDialog.vue?vue&type=script&lang=js&"
export * from "./columnsDialog.vue?vue&type=script&lang=js&"
import style0 from "./columnsDialog.vue?vue&type=style&index=0&id=54d8e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8e6b6",
  null
  
)

export default component.exports